var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-good-table',{staticClass:"default-table",attrs:{"columns":_vm.tableColumns,"rows":_vm.promocodes,"styleClass":"promocodes-table"},on:{"on-row-click":function($event){return _vm.$emit('on-row-click', $event.row.id)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }